import React from "react";
import axios from "axios";

import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";

import AddressComponent from "../common/contacts/Address";
import WorkingHoursComponent from "../common/contacts/WorkingHours";
import BasicDataComponent from "../common/contacts/BasicData";
import CommercialDataComponent from "../common/contacts/CommercialData";
import TaxDataComponent from "../common/contacts/TaxData";
import ProviderTasksComponent from "../common/contacts/ProviderTasks";
import CommentsComponent from "../common/Comments";
import MediaComponent from "../common/Media";
import HansaMediaComponent from "../common/HansaMedia";
//import SGOScoringComponent from '../common/contacts/SGOScoring'

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import api from "../common/api";

import LinearProgress from "@material-ui/core/LinearProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { userHasRole } from "../auth/UserFunctions";

class ProviderForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basic_data: {
        hansa_code: "",
        business_name: "",
        fantasy_name: "",
        provider_provider_types: [],
        email: "",
        phone: "",
        mobile: "",
        web: "",
        is_main_provider: true,
        unusual_provider: false,
        contact_checked: false,
        contact_checked_date: ""
      },
      tax_data: {
        country_id: "",
        document_number: "",
        cuit_date_verification: "",
        document_type_id: "",
        iva_type_buy_id: "",
        iva_type_sell_id: "",
        iva_type_id: "1"
      },
      address_data: [
        {
          id: "",
          code: "",
          type: "",
          street_number: "",
          floor: "",
          departament: "",
          others: "",
          street: ""
        }
      ],
      commercial_data: {
        rebate: "",
        payment_deadline: "",
        classification: "",
        discount: "",
        discount_in_vouchers: false,
        credit_limit: "",
        has_deposit_account: false,
        allow_advance: false,
        cbu: "",
        bank_id: "",
        bank_account_number: "",
        bank_branch: ""
      },
      working_hours_data: [{ day: [], hour_from: "", hour_to: "" }],
      //sgo_survey:[{id:1, question:"Pregunta 1", value:''}],
      tasks_data: {
        q_daily_operations: "",
        is_official: false,
        has_crane: false,
        has_safe_items: false,
        has_valet: false,
        brands: [],
        gamas: [],
        aditional_service: [],
        tasks: [{ tasks: [], performed_type_id: "" }],
        vehicle_types: [],
        tier_brands: [],
        equipment_type_id: "",
        has_iso_certification: false
      },
      tier_brands: [],
      places: [],
      iibb_types: [],
      invoice_types: [],
      errors: {},
      submitted: false,
      activeStep: 0,
      loading: true,
      dialogOpen: false,
      backdrop: false,
      cuitExists: false,
      action: "new",
      errorMessage: "",
      payment_deals: [],
      payment_methods: [],
      media: [],
      provider_types: [{}],
      banks: [],
      comment: "",
      provider_data: {},
      currency_types: [
        { id: "PES", name: "PESOS" },
        { id: "USD", name: "DOLARES" }
      ],
      providers_autocomplete: {
        loading: false,
        open: false,
        options: [{ business_name: "" }],
        provider: {}
      }
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.handleDeleteAddress = this.handleDeleteAddress.bind(this);
    this.handleNewComment = this.handleNewComment.bind(this);
    this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.addNewItem = this.addNewItem.bind(this);
    this.filterItem = this.filterItem.bind(this);
  }

  async componentDidMount() {
    let results = await this.setParams();
    var params = this.getParams();
    var provider_id = params.id;
    var view = params.view;
    await this.setParams();
    if (provider_id !== undefined) {
      var action = view === "1" ? "view" : "edit";
      await this.setProvider(provider_id);
      this.setState({ provider_id: provider_id });
      this.setState({ action: action });
      this.setState({ disabled: view });
    } else {
      this.setState({ action: "new" });
    }

    this.setState({ loading: false });
  }

  async setParams() {
    var additional_services_category_id = await this.getAdditionalServicesCategory();
    const token = localStorage.getItem("userToken");

    var results = await axios
      .all([
        axios.get(api.tasks, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(api.address_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.iva_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.iva_conditions, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.document_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.brands().index(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.gamas, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(api.vehicle_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.grouped_provider_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.equipment_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.countries, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.performed_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.categories().get(additional_services_category_id), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.client_iibb_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.invoice_types, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.payment_deals, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.payment_methods, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.vehicles().tier_brands(), {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(api.banks, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ])
      .then(
        axios.spread((...responses) => {
          const tasks = responses[0].data;
          const address_types = responses[1].data;
          const iva_types = responses[2].data;
          const iva_conditions = responses[3].data;
          const document_types = responses[4].data;
          const brands = responses[5].data;
          const gamas = responses[6].data;
          const vehicle_types = responses[7].data;
          const provider_types = responses[8].data;
          const equipment_types = responses[9].data;
          const countries = responses[10].data;
          const performed_types = responses[11].data;
          const additional_services = responses[12].data;
          const iibb_types = responses[13].data;
          const invoice_types = responses[14].data;
          const payment_deals = responses[15].data;
          const payment_methods = responses[16].data;
          const tier_brands = responses[17].data;
          const banks = responses[18].data;
          this.setState({
            provider_types,
            tasks,
            address_types,
            iva_types,
            iva_conditions,
            document_types,
            vehicle_types,
            equipment_types,
            gamas,
            brands,
            tier_brands,
            countries,
            performed_types,
            additional_services,
            iibb_types,
            invoice_types,
            payment_deals,
            payment_methods,
            banks
          });
        })
      );
    this.setState({ disabled: false });
  }
  getParams() {
    return this.props.match.params;
  }

  getApi(url, params) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        res.data = Object.values(res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  getProvider(id) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.providers().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async setProvider(id) {
    var provider_data = await this.getProvider(id);
    provider_data = provider_data;
    this.setState({ provider_data: provider_data });
    this.setState({ contact_id: provider_data.contact_id });
    var tasks_performed = [];
    var additional_services = [];

    var performed_type_id = 1;
    console.log("provider_data!!", provider_data);
    provider_data.tasks.map((val, idx) => {
      performed_type_id = val.performed_type_id;
      if (val.task.category_id !== 8) {
        tasks_performed.push({
          task: val.task.name,
          performed_type_id: val.performed_type_id
        });
      } else {
        additional_services.push(val.task.name);
      }
      return;
    });

    var last_performed_type_id =
      tasks_performed.length > 0 ? tasks_performed[0].performed_type_id : null;
    var task = [];
    var tasks = [];

    tasks_performed.map((val, idx) => {
      if (val.performed_type_id === last_performed_type_id) {
        task.push(val.task);
      } else {
        tasks.push({ tasks: task, performed_type_id: last_performed_type_id });
        task = [];
        task.push(val.task);
        last_performed_type_id = val.performed_type_id;
      }
    });
    tasks.push({ tasks: task, performed_type_id: last_performed_type_id });

    var vehicle_types = [];
    provider_data.vehicle_types.map((val, idx) => {
      vehicle_types.push(val.vehicle_type.name);
    });

    var gamas = [];
    provider_data.gamas.map((val, idx) => {
      gamas.push(val.name);
    });
    var brands = [];
    var tier_brands = [];
    provider_data.brands.map((val, idx) => {
      if (val.brand_type === "Vehiculos") brands.push(val.name);
      if (val.brand_type === "Neumaticos") tier_brands.push(val.name);
    });
    var schedules = [];
    var days = {
      0: "Domingo",
      1: "Lunes",
      2: "Martes",
      3: "Miércoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sabado"
    };
    var hour_from = "";
    var hour_to = "";
    var last_hour_from = "";
    var last_hour_to = "";

    if (provider_data.schedules[0]) {
      var last_hour_from = provider_data.schedules[0].hour_from;
      var last_hour_to = provider_data.schedules[0].hour_to;
    }
    var day = [];
    provider_data.schedules.map((val, idx) => {
      if (val.hour_to === last_hour_to && val.hour_from === last_hour_from) {
        day.push(days[val.day]);
      } else {
        schedules.push({
          day: day,
          hour_from: last_hour_from,
          hour_to: last_hour_to
        });
        day = [];
        day.push(days[val.day]);
        last_hour_to = val.hour_to;
        last_hour_from = val.hour_from;
      }
    });
    schedules.push({
      day: day,
      hour_from: last_hour_from,
      hour_to: last_hour_to
    });

    var address_data = [];
    var places = [];
    if (this.state.basic_data.is_main_provider !== false) {
      provider_data.contact.address.map((val, idx) => {
        var place = [];
        var street_number = "";
        if (JSON.parse(val.data).address_components[0].long_name === "S/N") {
          street_number = val.number;
        }

        address_data.push({
          id: val.id,
          code: val.code,
          type: val.address_type_id,
          street_number: street_number,
          street: val.street,
          number: val.number,
          floor: val.floor ? val.floor : "",
          departament: val.departament ? val.departament : "",
          others: val.others ? val.others : "",
          postal_code: val.postal_code
        });
        if (val.data !== "" && val.data !== null) {
          place.push(JSON.parse(val.data));
        } else {
          let geometry = {
            geometry: {
              location: { lat: parseFloat(val.lat), lng: parseFloat(val.long) }
            }
          };
          place.push(geometry);
        }
        places.push(place);
      });
    } else {
      provider_data.is_main_provider = 0;
      schedules = [];
      schedules.push({ day: [], hour_from: "", hour_to: "" });
    }
    if (address_data.length === 0) {
      address_data.push({
        id: "",
        code: "",
        type: "",
        street_number: "",
        floor: "",
        departament: "",
        others: "",
        street: ""
      });
    }

    var provider_provider_types = [];
    provider_data.types.map((val, idx) => {
      provider_provider_types.push(val.type.name);
    });
    var taxes =
      provider_data.contact.taxes !== null
        ? provider_data.contact.taxes
        : {
            country_id: "",
            document_number: "",
            cuit_date_verification: "",
            document_type_id: "",
            iva_type_buy_id: "",
            iva_type_sell_id: "",
            iva_type_id: ""
          };
    this.setState({
      basic_data: {
        hansa_code: provider_data.contact.hansa_code,
        sap_code: provider_data.sap_code ? provider_data.sap_code : "",
        sap_dimension: provider_data.sap_dimension
          ? provider_data.sap_dimension
          : "",
        business_name: provider_data.business_name,
        fantasy_name: provider_data.fantasy_name,
        provider_provider_types: provider_provider_types,
        email: provider_data.contact.email,
        phone: provider_data.contact.phone,
        mobile: provider_data.contact.mobile,
        web: provider_data.web !== null ? provider_data.web : "",
        is_main_provider:
          parseInt(provider_data.is_main_provider) === 0 ? false : true,
        unusual_provider:
          parseInt(provider_data.unusual_provider) === 0 ? false : true,
        contact_checked:
          parseInt(provider_data.contact.contact_checked) === 0 ? false : true,
        contact_checked_date: provider_data.contact.contact_checked_date
      },
      tax_data: {
        country_id: taxes.country_id,
        document_number: taxes.document_number,
        cuit_date_verification: this.formatDate(taxes.cuit_date_verification),
        document_type_id: taxes.document_type_id,
        iva_type_buy_id: taxes.iva_type_buy_id,
        iva_type_sell_id: taxes.iva_type_sell_id,
        iva_type_id: taxes.iva_type_id,
        client_iibb_type_id: provider_data.iibb_type_id
      },
      address_data: address_data,
      commercial_data: {
        rebate: provider_data.rebate,
        payment_deadline: provider_data.payment_deadline,
        classification: provider_data.classification,
        discount: provider_data.discount,
        discount_in_vouchers: provider_data.discount_in_vouchers,
        credit_limit: provider_data.credit_limit,
        has_deposit_account: provider_data.has_deposit_account,
        allow_advance: provider_data.allow_advance,
        invoice_type_id: provider_data.invoice_type_id,
        payment_method: provider_data.payment_method,
        currency: provider_data.currency,
        cost_account: provider_data.cost_account,
        cbu: provider_data.cbu,
        bank_id: provider_data.bank_id ? provider_data.bank_id : "",
        bank_account_number: provider_data.bank_account_number
          ? provider_data.bank_account_number
          : "",
        bank_branch: provider_data.bank_branch ? provider_data.bank_branch : ""
      },
      working_hours_data: schedules,
      tasks_data: {
        q_daily_operations: provider_data.q_daily_operations,
        is_official: provider_data.is_official,
        has_crane: provider_data.has_crane,
        has_safe_items: provider_data.has_safe_items,
        has_valet: provider_data.has_valet,
        brands: brands,
        tier_brands: tier_brands,
        gamas: gamas,
        aditional_service: additional_services,
        tasks: tasks,
        vehicle_types: vehicle_types,
        equipment_type_id: provider_data.equipment_type_id,
        performed_type_id: performed_type_id,
        has_iso_certification:
          parseInt(provider_data.has_iso_certification) === 0 ? false : true
      },
      places: places,
      comments: provider_data.comments,
      media: provider_data.media
    });
  }

  formatDate(date) {
    if (date === "" || date === null || date === "null") {
      return null;
    }
    //hansa_start_date = '2019-12-31'
    //return newDate[2]
    let fromDate = new Date(date);
    let year = fromDate.getFullYear();

    let month = fromDate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day =
      fromDate.getDate() < 10 ? "0" + fromDate.getDate() : fromDate.getDate();
    //return fromDate.getFullYear() + "-" + (fromDate.getMonth()+1) + "-" + fromDate.getDate();

    return year + "-" + month + "-" + day;
  }

  getcategoriesAll() {
    return this.getApi(api.categories().getAll());
  }

  async getAdditionalServicesCategory() {
    var categories = await this.getcategoriesAll();
    var id = "";

    categories.map((val, idx) => {
      if (val.name.toUpperCase() === "SERVICIOS EXTRA PROVEEDOR") {
        id = val.id;
      }
    });

    return id;
  }

  addNewItem(mod) {
    var state = this.state;
    switch (mod) {
      case "working_hours_data":
        state.working_hours_data.push({ day: [], hour_from: "", hour_to: "" });
        break;
      case "tasks_data":
        state.tasks_data.tasks.push({ tasks: [], performed_type_id: "" });
        break;
    }
    this.setState({ state });
  }

  filterItem(mod, id) {
    var state = this.state;
    switch (mod) {
      case "working_hours_data":
        state.working_hours_data = state.working_hours_data.filter(
          (s, sidx) => id !== sidx
        );
        break;
      case "tasks_data":
        state.tasks_data.tasks = state.tasks_data.tasks.filter(
          (s, sidx) => id !== sidx
        );
        break;
    }
    this.setState({ state });
  }

  handleChange = (event, mod) => {
    var key = event.target.name;
    var val = event.target.value;
    switch (mod) {
      case "basic_data":
        var basic_data = this.state.basic_data;
        if (
          key === "is_main_provider" ||
          key === "contact_checked" ||
          key === "unusual_provider"
        ) {
          val = event.target.checked;
        }

        basic_data[key] = val;

        this.setState({ basic_data: basic_data });
        return "";

      case "address_data":
        var address_data = this.state.address_data;
        var data = key.split(".");
        if (data[0] === "code") {
          address_data[data[1]].code = val;
        }
        if (data[0] === "street_number") {
          address_data[data[1]].street_number = val;
        } else if (data[0] === "postal_code") {
          address_data[data[1]].postal_code = val;
        } else if (data[0] === "type") {
          address_data[data[1]].type = val;
        } else if (data[0] === "floor") {
          address_data[data[1]].floor = val;
        } else if (data[0] === "departament") {
          address_data[data[1]].departament = val;
        } else if (data[0] === "others") {
          address_data[data[1]].others = val;
        } else if (data[0] === "street") {
          address_data[data[1]].street = val;
        }
        this.setState({ address_data: address_data });
        return "";

      case "tax_data":
        var tax_data = this.state.tax_data;
        tax_data[key] = val;
        this.setState({ tax_data: tax_data });
        return "";

      case "commercial_data":
        var commercial_data = this.state.commercial_data;
        if (key === "credit_limit") {
          //val = val
          val = val.replace("$", "").replace(/\./g, "");
        }
        if (key === "discount" || key === "rebate") {
          val = val.replace("%", "").replace(/\,/g, "");
        }

        /*        if (key === 'payment_deadline'){
          val = parseInt(Math.abs(val))
        }
*/
        /*        if (key === 'classification'){
          val = (Math.round(val * 100) / 100).toFixed(2)
        }
        */
        if (key === "has_deposit_account" || key === "discount_in_vouchers") {
          val = event.target.checked;
        }

        if (key === "allow_advance") {
          val = event.target.checked;
        }

        commercial_data[key] = val;
        this.setState({ commercial_data: commercial_data });
        return "";

      case "working_hours_data":
        var working_hours_data = this.state.working_hours_data;
        var res = event.target.name.split(".");
        key = res[0];
        var id = res[1];
        if (key === "day") {
          working_hours_data[id].day = val;
        } else if (key === "hour_from") {
          working_hours_data[id].hour_from = val;
        } else {
          working_hours_data[id].hour_to = val;
        }
        this.setState({ working_hours_data: working_hours_data });

        return "";

      case "tasks_data":
        var tasks_data = this.state.tasks_data;
        if (
          [
            "has_valet",
            "has_crane",
            "has_safe_items",
            "is_official",
            "has_iso_certification"
          ].includes(key)
        ) {
          val = event.target.checked;
        }
        tasks_data[key] = val;

        if (key.includes("tasks") || key.includes("performed_type_id")) {
          var res = event.target.name.split(".");
          key = res[0];
          var id = res[1];
          if (key === "tasks") {
            tasks_data.tasks[id].tasks = val;
          } else {
            tasks_data.tasks[id].performed_type_id = val;
          }
        }
        this.setState({ tasks_data: tasks_data });
        return "";
    }
  };

  handleProvidersAsyncChange = (event, values) => {
    var providers_autocomplete = this.state.providers_autocomplete;
    values = values !== null ? values : { business_name: "" };
    providers_autocomplete.provider = values;
    this.setState({ providers_autocomplete: providers_autocomplete });

    if (values.contact !== undefined) {
      this.setProvider(values.id);
    }
  };

  handleProvidersAsyncSearch = (event, values) => {
    var provider = values;
    const token = localStorage.getItem("userToken");
    if (provider.length > 2) {
      return axios
        .get(api.providers().index(1, provider, "", "", "", "", "", "", 1), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var providers_autocomplete = this.state.providers_autocomplete;
          providers_autocomplete.options = res.data.data;
          this.setState({ providers_autocomplete: providers_autocomplete });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handlePlaceSearch = newPlaces => {
    var address_data = this.state.address_data;
    var code = address_data.length.toString().padStart(4, "0");
    var i = address_data.length > 0 ? address_data.length - 1 : 0;
    address_data[i].code = code;
    address_data.push({ id: "", code: "", type: "" });

    this.setState({ places: newPlaces, address_data: address_data });
  };

  handleDelete(type, value) {
    var data = [];
    var key = "";
    var subkey = "";
    var model_name = "";
    var feature_name = "id";
    switch (type) {
      case "gamas":
        data = this.state.provider_data.gamas
          ? this.state.provider_data.gamas
          : [];
        key = "name";
        model_name = "GamaProvider";
        break;
      case "brands":
        data = this.state.provider_data.brands
          ? this.state.provider_data.brands
          : [];
        key = "name";
        model_name = "BrandProvider";
        break;
      case "tasks":
        data = this.state.provider_data.tasks
          ? this.state.provider_data.tasks
          : [];
        key = "task";
        subkey = "name";
        model_name = "ProviderTask";
        break;
      case "vehicle_types":
        data = this.state.provider_data.vehicle_types
          ? this.state.provider_data.vehicle_types
          : [];
        key = "vehicle_type";
        subkey = "name";
        model_name = "ProviderVehicleType";
        break;
      case "schedules":
        data = this.state.provider_data.schedules
          ? this.state.provider_data.schedules
          : [];
        key = "day";
        model_name = "Schedule";
        break;
      case "provider_provider_types":
        data = this.state.provider_data.types
          ? this.state.provider_data.types
          : [];
        key = "name";
        model_name = "ProviderProviderType";
    }
    if (model_name === "GamaProvider" || model_name === "BrandProvider") {
      data.map((val, id) => {
        if (val[key] === value) {
          this.setState({
            delete_feature: true,
            errors: false,
            feature_item: val.pivot.id,
            feature_item_idx: id,
            feature_value: val.name,
            model_name: model_name,
            feature_name: feature_name,
            dialogOpen: true,
            message: "Esta a punto de eliminar el registro. ¿Está seguro?"
          });
        }
      });
    } else if (
      model_name === "ProviderVehicleType" ||
      model_name === "ProviderTask"
    ) {
      data.map((val, id) => {
        if (val[key][subkey] === value) {
          this.setState({
            delete_feature: true,
            errors: false,
            feature_item: val.id,
            feature_item_idx: id,
            feature_value: value,
            model_name: model_name,
            feature_name: feature_name,
            dialogOpen: true,
            message: "Esta a punto de eliminar el registro. ¿Está seguro?"
          });
        }
      });
    } else if (model_name === "Schedule") {
      var days = {
        Domingo: 0,
        Lunes: 1,
        Martes: 2,
        Miércoles: 3,
        Jueves: 4,
        Viernes: 5,
        Sabado: 6
      };
      data.map((val, idx) => {
        if (val.day === days[value]) {
          this.setState({
            delete_feature: true,
            errors: false,
            feature_item: val.id,
            feature_item_idx: idx,
            feature_value: value,
            model_name: model_name,
            feature_name: feature_name,
            dialogOpen: true,
            message: "Esta a punto de eliminar el registro. ¿Está seguro?"
          });
        }
      });
    } else if (model_name === "ProviderProviderType") {
      data.map((val, idx) => {
        if (val.type.name === value) {
          this.setState({
            delete_feature: true,
            errors: false,
            feature_item: val.id,
            feature_item_idx: idx,
            feature_value: value,
            model_name: model_name,
            feature_name: feature_name,
            dialogOpen: true,
            message: "Esta a punto de eliminar el registro. ¿Está seguro?"
          });
        }
      });
    }
  }

  validateCuit = async () => {
    var cuit = this.state.tax_data.document_number;
    var cuitExists = false;
    var contacts = await this.getApi(api.contacts().validateCuit(cuit));
    if (contacts) {
      var contact = contacts.filter(
        contact => contact.id.toString() !== this.state.contact_id
      );

      if (contact[0]) {
        if (contact[0].provider) {
          if (contact[0].provider && contact[0].provider.is_main_provider) {
            cuitExists = true;
          }
        }
      }
    }
    this.setState({ cuitExists: cuitExists });
  };

  handleConfirmDelete() {
    var value = this.state.feature_value;
    var idx = this.state.feature_item_idx;
    switch (this.state.model_name) {
      case "BrandProvider":
        var data = this.state.tasks_data;
        data.brands.map((val, idx) => {
          if (val === value) {
            data.brands = data.brands.filter((s, sidx) => idx !== sidx);
          }
        });
        this.setState({ tasks_data: data });
        break;
      case "GamaProvider":
        var data = this.state.tasks_data;
        data.gamas.map((val, idx) => {
          if (val === value) {
            data.gamas = data.gamas.filter((s, sidx) => idx !== sidx);
          }
        });
        this.setState({ tasks_data: data });
        break;
      case "ProviderTask":
        var data = this.state.tasks_data;
        data.tasks.map((val, idx) => {
          if (val === value) {
            data.tasks = data.tasks.filter((s, sidx) => idx !== sidx);
          }
        });
        data.aditional_service.map((val, idx) => {
          if (val === value) {
            data.aditional_service = data.aditional_service.filter(
              (s, sidx) => idx !== sidx
            );
          }
        });

        this.setState({ tasks_data: data });
        break;
      case "ProviderVehicleType":
        var data = this.state.tasks_data;
        data.vehicle_types.map((val, idx) => {
          if (val === value) {
            data.vehicle_types = data.vehicle_types.filter(
              (s, sidx) => idx !== sidx
            );
          }
        });
        this.setState({ tasks_data: data });
        break;
      case "Schedule":
        var data = this.state.working_hours_data;
        data.day.map((val, idx) => {
          if (val === value) {
            data.day = data.day.filter((s, sidx) => idx !== sidx);
          }
        });
        this.setState({ working_hours_data: data });
        break;
      case "ProviderProviderType":
        var data = this.state.basic_data;
        data.provider_provider_types.map((val, idx) => {
          if (val === value) {
            data.provider_provider_types = data.provider_provider_types.filter(
              (s, sidx) => idx !== sidx
            );
          }
        });
        this.setState({ provider_data: data });
        break;
    }
    var formData = new FormData();
    formData.set(
      "feature[" + this.state.feature_name + "]",
      this.state.feature_item
    );
    formData.set("feature[deleted_at]", 1);
    formData.set("feature[provider_id]", this.state.provider_id);
    formData.set("model", this.state.model_name);

    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.providers().feature(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        self.setState({ message: "Registro eliminado con éxito!" });
        self.setState({
          errors: false,
          feature_value: false,
          feature_deleted: true,
          feature_item: false,
          feature_name: false,
          delete_feature: false,
          model_name: false,
          dialogOpen: true
        });
      })
      .catch(function(error) {
        self.setState({ errors: true });
        self.setState({
          message:
            "Hubo un problema al eliminar el regsitro. Por favor volver a intentar"
        });
        self.setState({ dialogOpen: true });
        self.setState({ feature_item: false });
        self.setState({ feature_name: false });
        self.setState({ delete_feature: false });
        self.setState({ model_name: false });
      });
  }

  handleSubmit = event => {
    this.setState({ backdrop: true });
    event.preventDefault();
    event.stopPropagation();
    if (this.handleValidations(this.state.activeStep) !== true) {
      this.setState({
        dialogOpen: true,
        message:
          "Hay errores en la carga o faltan carga campos. Por favor revisar",
        errors: true
      });
    } else {
      var formData = new FormData();

      var item = this.state.basic_data;
      for (var key in item) {
        if (
          typeof item[key] != undefined &&
          item[key] != null &&
          key !== "provider_provider_types" &&
          key !== "fantasy_name" &&
          key !== "business_name" &&
          key !== "is_main_provider" &&
          key !== "unusual_provider" &&
          key !== "contact_checked"
        ) {
          formData.set("contact[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }

      formData.set(
        "contact[contact_checked]",
        this.state.basic_data.contact_checked === true ? 1 : 0
      );
      formData.set(
        "contact[document_number]",
        this.state.tax_data.document_number
      );
      formData.set(
        "contact[document_type]",
        this.state.tax_data.document_type_id
      );
      formData.set(
        "provider[business_name]",
        this.state.basic_data.business_name
      );
      formData.set(
        "provider[fantasy_name]",
        this.state.basic_data.fantasy_name
      );
      formData.set(
        "provider[unusual_provider]",
        this.state.basic_data.unusual_provider === true ? 1 : 0
      );
      formData.set(
        "provider[is_main_provider]",
        this.state.basic_data.is_main_provider === true ? 1 : 0
      );
      formData.set(
        "provider[iibb_type_id]",
        this.state.tax_data.client_iibb_type_id
          ? this.state.tax_data.client_iibb_type_id
          : "1"
      );
      formData.set(
        "provider[web]",
        this.state.basic_data.web !== "" || this.state.basic_data.web !== null
          ? this.state.basic_data.web
          : ""
      );
      formData.set(
        "provider[invoice_type_id]",
        this.state.commercial_data.invoice_type_id
          ? this.state.commercial_data.invoice_type_id
          : "1"
      );

      for (var key in this.state.basic_data.provider_provider_types) {
        for (var key2 in this.state.provider_types) {
          if (
            this.state.provider_types[key2].name ===
            this.state.basic_data.provider_provider_types[key]
          ) {
            formData.set(
              "provider[provider_types][" + key + "][provider_type_id]",
              this.state.provider_types[key2].id
            );
          }
        }
      }

      var item = this.state.places;
      for (var key in item) {
        if (
          typeof item[key] != undefined &&
          item[key] != null &&
          item[key] !== ""
        ) {
          formData.set(
            "contact[address][" + key + "][code]",
            this.state.address_data[key].code
              ? this.state.address_data[key].code
              : ""
          );
          formData.set(
            "contact[address][" + key + "][address_type_id]",
            this.state.address_data[key].type
          );
          formData.set(
            "contact[address][" + key + "][country_id]",
            this.state.tax_data.country_id
          ); // address_component route 1
          formData.set(
            "contact[address][" + key + "][street]",
            this.state.places[key][0].address_components[1].short_name !== "AR"
              ? this.state.places[key][0].address_components[1].long_name
              : this.state.address_data[key].street
          ); // address_component route 1
          formData.set(
            "contact[address][" + key + "][number]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.address_data[key].street_number
              : this.state.places[key][0].address_components[0].long_name
          ); // address_component street_number 0
          //            formData.set("contact[address]["+key+"][number]", this.state.places[key][0].address_components[0].long_name); // address_component street_number 0
          //            formData.set("contact[address]["+key+"][postal_code]",(this.state.places[key][0].address_components[6])?this.state.places[key][0].address_components[6].long_name:1); // address_component postal_code 6
          formData.set(
            "contact[address][" + key + "][postal_code]",
            this.state.places[key][0].address_components[6]
              ? this.state.places[key][0].address_components[6].long_name
              : this.state.address_data[key].postal_code
          ); // address_component postal_code 6
          formData.set(
            "contact[address][" + key + "][province]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.places[key][0].address_components[3].long_name
              : this.state.places[key][0].address_components[4].long_name
          ); // address_component administrative_area_level_1 4
          formData.set(
            "contact[address][" + key + "][state]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.places[key][0].address_components[3].long_name
              : this.state.places[key][0].address_components[3].long_name
          ); // address_component administrative_area_level_1 4

          //            formData.set("contact[address]["+key+"][province]", this.state.places[key][0].address_components[4].long_name); // address_component administrative_area_level_1 4
          //            formData.set("contact[address]["+key+"][state]", this.state.places[key][0].address_components[3].long_name); // ??

          formData.set(
            "contact[address][" + key + "][lat]",
            this.state.address_data[key].id
              ? this.state.places[key][0].geometry.location.lat
              : this.state.places[key][0].geometry.location.lat()
          ); // this.state.places[key][0].geometry.location.lat()
          formData.set(
            "contact[address][" + key + "][long]",
            this.state.address_data[key].id
              ? this.state.places[key][0].geometry.location.lng
              : this.state.places[key][0].geometry.location.lng()
          ); // this.state.places[key][0].geometry.location.log()
          formData.set(
            "contact[address][" + key + "][data]",
            JSON.stringify(this.state.places[key][0])
          ); // this.state.places[key][0]
          formData.set(
            "contact[address][" + key + "][floor]",
            this.state.address_data[key].floor
              ? this.state.address_data[key].floor
              : ""
          );
          formData.set(
            "contact[address][" + key + "][departament]",
            this.state.address_data[key].departament
              ? this.state.address_data[key].departament
              : ""
          );
          formData.set(
            "contact[address][" + key + "][others]",
            this.state.address_data[key].others
              ? this.state.address_data[key].others
              : ""
          );
        }
        if (this.state.action === "edit" && this.state.address_data[key].id) {
          formData.set(
            "contact[address][" + key + "][id]",
            this.state.address_data[key].id
          );
        }
      }
      var i = 0;
      var item = this.state.working_hours_data;
      var days = {
        Domingo: 0,
        Lunes: 1,
        Martes: 2,
        Miércoles: 3,
        Jueves: 4,
        Viernes: 5,
        Sabado: 6
      };

      var i = 0;
      for (var key in this.state.working_hours_data) {
        for (var key2 in this.state.working_hours_data[key].day) {
          if (
            typeof this.state.working_hours_data[key].day[key2] !== undefined &&
            this.state.working_hours_data[key].day[key2] !== null &&
            this.state.working_hours_data[key].hour_from
          ) {
            formData.set(
              "provider[schedules][" + i + "][day]",
              days[this.state.working_hours_data[key].day[key2]]
            );
            formData.set(
              "provider[schedules][" + i + "][hour_from]",
              this.state.working_hours_data[key].hour_from
            );
            formData.set(
              "provider[schedules][" + i + "][hour_to]",
              this.state.working_hours_data[key].hour_to
            );
            i++;
          }
        }
      }

      /*      for ( var key in item ) {
        var day = item['day']
        for (var key2 in day){
          if (typeof day[key2] !== undefined && day[key2] !== null && this.state.working_hours_data[key].hour_from){
              formData.set("provider[schedules]["+i+"][day]", days[day[key]]);
              formData.set("provider[schedules]["+i+"][hour_from]", this.state.working_hours_data.hour_from);
              formData.set("provider[schedules]["+i+"][hour_to]", this.state.working_hours_data.hour_to);
              //console.log(key, item[key])
              i++;
          }
        }
      }
*/
      for (var key in this.state.tasks_data.vehicle_types) {
        for (var key2 in this.state.vehicle_types) {
          if (
            this.state.vehicle_types[key2].name ===
            this.state.tasks_data.vehicle_types[key]
          ) {
            formData.set(
              "provider[vehicle_types][" + key + "][vehicle_type_id]",
              this.state.vehicle_types[key2].id
            );
          }
        }
      }

      let i_brand = 0;
      for (var key in this.state.tasks_data.brands) {
        for (var key2 in this.state.brands) {
          if (
            this.state.brands[key2].name === this.state.tasks_data.brands[key]
          ) {
            formData.set(
              "provider[brands][" + i_brand + "][brand_id]",
              this.state.brands[key2].id
            );
            formData.set(
              "provider[brands][" + i_brand + "][brand_type]",
              "Vehiculos"
            );
            i_brand++;
          }
        }
      }

      for (var key in this.state.tasks_data.tier_brands) {
        for (var key2 in this.state.tier_brands) {
          if (
            this.state.tier_brands[key2].name ===
            this.state.tasks_data.tier_brands[key]
          ) {
            formData.set(
              "provider[brands][" + i_brand + "][brand_id]",
              this.state.tier_brands[key2].id
            );
            formData.set(
              "provider[brands][" + i_brand + "][brand_type]",
              "Neumaticos"
            );
            i_brand++;
          }
        }
      }

      for (var key in this.state.tasks_data.gamas) {
        for (var key2 in this.state.gamas) {
          if (
            this.state.gamas[key2].name === this.state.tasks_data.gamas[key]
          ) {
            formData.set(
              "provider[gamas][" + key + "][gama_id]",
              this.state.gamas[key2].id
            );
          }
        }
      }

      /*      for ( var key in this.state.tasks_data ) {
          for (var key2 in this.state.tasks ) {
            if (this.state.tasks[key2].name === this.state.tasks_data.tasks[key].tasks ){
              formData.set("provider[tasks]["+key+"][task_id]]", this.state.tasks[key2].id);
              formData.set("provider[tasks]["+key+"][enabled]]", 1);
              formData.set("provider[tasks]["+key+"][performed_type_id]]", this.state.tasks_data.performed_type_id);
            }
          }
      }
*/

      var i = 0;
      for (var key in this.state.tasks_data.tasks) {
        for (var key2 in this.state.tasks_data.tasks[key].tasks) {
          for (var key3 in this.state.tasks) {
            if (
              this.state.tasks[key3].name ===
              this.state.tasks_data.tasks[key].tasks[key2]
            ) {
              formData.set(
                "provider[tasks][" + i + "][task_id]]",
                this.state.tasks[key3].id
              );
              formData.set("provider[tasks][" + i + "][enabled]]", 1);
              formData.set(
                "provider[tasks][" + i + "][performed_type_id]]",
                this.state.tasks_data.tasks[key].performed_type_id
                  ? this.state.tasks_data.tasks[key].performed_type_id
                  : 1
              );
              i++;
            }
          }
        }
      }

      for (var key in this.state.tasks_data.aditional_service) {
        for (var key2 in this.state.additional_services) {
          if (
            this.state.additional_services[key2].name ===
            this.state.tasks_data.aditional_service[key]
          ) {
            formData.set(
              "provider[tasks][" + i + "][task_id]]",
              this.state.additional_services[key2].id
            );
            formData.set("provider[tasks][" + i + "][enabled]]", 1);
            i++;
          }
        }
      }

      var item = this.state.tax_data;
      for (var key in item) {
        if (
          typeof item[key] != undefined &&
          item[key] != null &&
          key !== "client_iibb_type_id"
        ) {
          formData.set("tax[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }

      var item = this.state.commercial_data;
      for (var key in item) {
        if (
          typeof item[key] != undefined &&
          item[key] != null &&
          item[key] !== "" &&
          item[key] !== 0
        ) {
          formData.set("provider[" + key + "]", item[key]);
        }
      }

      formData.set(
        "provider[is_official]",
        this.state.tasks_data.is_official ? 1 : 0
      );
      formData.set(
        "provider[has_crane]",
        this.state.tasks_data.has_crane ? 1 : 0
      );
      formData.set(
        "provider[has_safe_items]",
        this.state.tasks_data.has_safe_items ? 1 : 0
      );
      formData.set(
        "provider[has_valet]",
        this.state.tasks_data.has_valet ? 1 : 0
      );
      formData.set(
        "provider[has_deposit_account]",
        this.state.commercial_data.has_deposit_account ? 1 : 0
      );
      formData.set(
        "provider[discount_in_vouchers]",
        this.state.commercial_data.discount_in_vouchers ? 1 : 0
      );
      formData.set(
        "provider[allow_advance]",
        this.state.commercial_data.allow_advance ? 1 : 0
      );
      formData.set(
        "provider[equipment_type_id]",
        this.state.tasks_data.equipment_type_id
          ? this.state.tasks_data.equipment_type_id
          : 1
      );
      formData.set(
        "provider[q_daily_operations]",
        this.state.tasks_data.q_daily_operations
          ? this.state.tasks_data.q_daily_operations
          : 0
      );
      formData.set(
        "provider[has_iso_certification]",
        this.state.tasks_data.has_iso_certification ? 1 : 0
      );

      if (this.state.files) {
        this.state.files.map((val, idx) => {
          formData.set(`media[${idx}]`, val);
        });
      }

      if (this.state.comment !== "") {
        formData.set("comment", this.state.comment);
      }

      let self = this;
      const token = localStorage.getItem("userToken");
      if (this.state.action === "new") {
        axios
          .post(api.providers().post(), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            self.setState({ errors: false });
            self.setState({ save_provider: true });
            self.setState({ message: "Proveedor creado con éxito!" });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          })
          .catch(function(error) {
            self.setState({ errors: true });
            self.setState({
              message:
                "Hubo un problema al guardar el proveedor. Por favor volver a intentar"
            });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          });
      } else {
        formData.set("contact[id]", this.state.contact_id);
        formData.append("_method", "patch");
        axios
          .post(api.providers().patch(this.state.provider_id), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            self.setState({ save_provider: true });
            self.setState({ errors: false });
            self.setState({ message: "Proveedor modificado con éxito!" });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          })
          .catch(function(error) {
            self.setState({ errors: true });
            self.setState({
              message:
                "Hubo un problema al guardar el proveedor. Por favor volver a intentar"
            });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          });
      }
    }
  };

  removeItem = idx => () => {
    var address_data = this.state.address_data;
    if (address_data[idx]["id"] === "") {
      address_data = address_data.filter((s, sidx) => idx !== sidx);
      if (address_data.length === 0) {
        address_data.push({ code: "", type: "", id: "" });
      }
      var places = this.state.places;
      places = places.filter((s, sidx) => idx !== sidx);
      this.setState({ address_data: address_data, places: places });
    } else {
      this.setState({
        feature_deleted: false,
        dialogOpen: true,
        message: "Esta a punto de eliminar el domicilio. ¿Está seguro?",
        address_id: address_data[idx]["id"],
        delete_address: true,
        errors: false,
        delete_feature: false
      });
    }
  };

  handleDeleteAddress() {
    var address_data = this.state.address_data;
    var places = this.state.places;
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .delete(api.contacts().deleteAddress(this.state.address_id), {
        headers: { Authorization: `Bearer ${token}` },
        params: { "address[id]": this.state.address_id }
      })
      .then(response => {
        self.setState({ errors: false });
        self.setState({ delete_address: false });
        address_data.map((val, idx) => {
          if (val.id === this.state.address_id) {
            address_data = address_data.filter((s, sidx) => idx !== sidx);
            places = places.filter((s, sidx) => idx !== sidx);
          }
        });
        self.setState({
          address_id: "",
          address_data: address_data,
          places: places
        });
        self.setState({ dialogOpen: true, feature_deleted: true });
        self.setState({ message: "Registro eliminado con éxito!" });
      })
      .catch(function(error) {
        self.setState({ errors: true });
        self.setState({ delete_address: false });
        self.setState({
          message:
            "El domicilio es el único del contacto. Ingrese uno nuevo para poder eliminar."
        });
        self.setState({ dialogOpen: true });
        self.setState({ address_id: "" });
      });
  }

  handleUpload(files) {
    this.setState({
      files: files
    });
  }

  handleNewComment(comment) {
    this.setState({ comment: comment });
  }

  handleCommentSubmit() {
    if (this.state.action !== "new") {
      var formData = new FormData();
      formData.set("comment", this.state.comment);
      let self = this;
      const token = localStorage.getItem("userToken");
      axios
        .post(api.providers().comment(this.state.provider_id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ comment: "" });
          self.setState({ errors: false });
          self.setState({ dialogOpen: true, feature_deleted: true });
          self.setState({ message: "Comentario guardado con exito!" });
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({ delete_address: false });
          self.setState({
            message:
              "No se pudo guardar tu comentario. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
        });
    } else {
      alert("Su comentario se agregará al guardar el proveedor");
    }
  }

  getStepContent(step) {
    var disabled = this.state.disabled;
    switch (step) {
      case 0:
        return [
          <BasicDataComponent
            disabled={disabled}
            title="Datos básicos"
            error={this.state.errorMessage}
            onChange={this.handleChange}
            basic_data={this.state.basic_data}
            provider_types={this.state.provider_types}
            provider_data={this.state.provider_data}
            onDelete={this.handleDelete}
            onProvidersAsyncChange={this.handleProvidersAsyncChange}
            onProvidersAsyncSearch={this.handleProvidersAsyncSearch}
            providers_autocomplete={this.state.providers_autocomplete}
          />,
          <div>
            <CommercialDataComponent
              disabled={disabled || !this.state.basic_data.is_main_provider}
              commercial_data={this.state.commercial_data}
              title="Datos comerciales"
              onChange={this.handleChange}
              invoice_types={this.state.invoice_types}
              payment_deals={this.state.payment_deals}
              payment_methods={this.state.payment_methods}
              currency_types={this.state.currency_types}
              banks={this.state.banks}
            />
          </div>
        ];
      case 1:
        return [
          <div>
            <AddressComponent
              disabled={disabled}
              error={this.state.errorMessage}
              address_data={this.state.address_data}
              places={this.state.places}
              address_types={this.state.address_types}
              title="Direcciones"
              onDeleteMarks={this.deleteMarkS}
              onRemoveItem={this.removeItem}
              onPleaceSearch={this.handlePlaceSearch}
              onChange={this.handleChange}
              onForceUpdate={this.forceUpdate}
            />
          </div>
        ];
      case 2:
        return (
          <TaxDataComponent
            disabled={disabled || !this.state.basic_data.is_main_provider}
            error={this.state.errorMessage}
            countries={this.state.countries}
            tax_data={this.state.tax_data}
            document_types={this.state.document_types}
            iva_types={this.state.iva_types}
            iva_conditions={this.state.iva_conditions}
            title="Datos impositivos"
            onChange={this.handleChange}
            iibb_types={this.state.iibb_types}
            validateCuit={this.validateCuit}
          />
        );
      //      case 3:
      //        return true ; <SGOScoringComponent disabled={disabled} error={this.state.errorMessage} sgo_questions={this.state.sgo_survey} />;
      case 3:
        return [
          <div>
            <WorkingHoursComponent
              provider_data={this.state.provider_data}
              disabled={disabled}
              working_hours_data={this.state.working_hours_data}
              title="Horarios de atención"
              onChange={this.handleChange}
              onDelete={this.handleDelete}
              addNewItem={this.addNewItem}
              removeItem={this.filterItem}
            />
          </div>,
          <div>
            <ProviderTasksComponent
              provider_data={this.state.provider_data}
              disabled={disabled}
              error={this.state.errorMessage}
              tasks_data={this.state.tasks_data}
              title="Tareas provistas"
              onChange={this.handleChange}
              onDelete={this.handleDelete}
              additional_services={this.state.additional_services}
              tasks={this.state.tasks}
              tier_brands={this.state.tier_brands}
              brands={this.state.brands}
              gamas={this.state.gamas}
              vehicle_types={this.state.vehicle_types}
              equipment_types={this.state.equipment_types}
              performed_types={this.state.performed_types}
              addNewItem={this.addNewItem}
              removeItem={this.filterItem}
            />
          </div>,
          <div>
            <CommentsComponent
              comments={this.state.comments}
              onChange={this.handleNewComment}
              onSubmit={this.handleCommentSubmit}
              disabled={this.state.disabled}
            />
          </div>,
          <div>
            <MediaComponent
              media={this.state.media}
              onChange={this.handleUpload}
              disabled={this.state.disabled}
            />
            <HansaMediaComponent
              hansa_code={this.state.basic_data.hansa_code}
              model="Provider"
            />
          </div>
        ];

      default:
        return [
          <BasicDataComponent
            title="Datos básicos"
            onChange={this.handleChange}
            basic_data={this.state.basic_data}
          />,
          <div>
            <CommercialDataComponent
              commercial_data={this.state.commercial_data}
              title="Datos comerciales"
              onChange={this.handleChange}
            />
          </div>
        ];
    }
  }

  handleValidations = step => {
    if (this.state.action !== "view") {
      switch (step) {
        case 0:
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          var isEmailValid = re.test(
            String(this.state.basic_data.email).toLowerCase()
          );
          var is_main_provider_ok = true;
          var errorMessage =
            "Debe completar los siguientes campos: Razón social, nombre comercial, tipo de proveedor y email válido.";
          if (!this.state.basic_data.is_main_provider) {
            is_main_provider_ok =
              this.state.basic_data.hansa_code !== "" ? true : false;
            errorMessage =
              "Debe completar los siguientes campos: Razón social, nombre comercial, tipo de proveedor y email válido. Debe elegir una casa central.";
          }

          if (
            this.state.commercial_data.cbu === "" ||
            this.state.commercial_data.cbu === null
          ) {
            errorMessage +=
              " Debe completar los siguientes campos: CBU, cuenta bancaria y banco.";
          }
          this.setState({ errorMessage: errorMessage });
          return (
            this.state.basic_data.business_name !== "" &&
            this.state.basic_data.fantasy_name !== "" &&
            this.state.basic_data.provider_provider_types.length !== 0 &&
            this.state.basic_data.email !== "" &&
            isEmailValid &&
            is_main_provider_ok
          );
        case 1:
          var address_data_valid = true;
          if (this.state.places.length !== 0) {
            this.state.places.map((val, idx) => {
              address_data_valid =
                address_data_valid &&
                this.state.address_data[idx].code !== "" &&
                this.state.address_data[idx].type !== "";
              if (
                this.state.places[idx][0].address_components[0].long_name ===
                "S/N"
              ) {
                address_data_valid =
                  address_data_valid &&
                  this.state.address_data[idx].street_number !== "";
              }
            });

            this.setState({
              errorMessage:
                "Los domicilios deben tener un código y tipo de domicilio cargado."
            });
          } else {
            address_data_valid = false;
            this.setState({
              errorMessage: "Debe cargar al menos un domicilio."
            });
          }
          return address_data_valid;

        case 2:
          var cuit = this.state.tax_data.document_number;
          var regex = /-/gi;
          cuit = cuit.replace(regex, "");
          regex = /_/gi;
          cuit = cuit.replace(regex, "");

          var date = this.state.tax_data.cuit_date_verification;
          var today = new Date();
          var errorMessage = "";

          if (
            this.state.tax_data.country_id === "" ||
            this.state.tax_data.document_number === "" ||
            this.state.tax_data.document_type === ""
          ) {
            errorMessage =
              "Debe completar los siguientes campos: País, número, tipo de documento e IVA. ";
          }
          if (
            this.state.tax_data.iva_type_id === "" ||
            this.state.tax_data.iva_type_id === undefined
          ) {
            errorMessage =
              "Debe completar los siguientes campos: País, número, tipo de documento e IVA. ";
          }
          if (this.state.cuitExists) {
            errorMessage += " El CUIT ya existe. ";
          }

          /*if ((this.state.tax_data.iva_type_buy_id === '' || this.state.tax_data.iva_type_buy_id === undefined)){
                  errorMessage = 'Debe completar los siguientes campos: País, número, tipo de documento e IVA. ' 
                }
                if ((this.state.tax_data.iva_type_sell_id === '' || this.state.tax_data.iva_type_sell_id === undefined)){
                  errorMessage = 'Debe completar los siguientes campos: País, número, tipo de documento e IVA. ' 
                }*/
          if (cuit.length !== 11) {
            errorMessage += " El formato del cuit no es el correcto. ";
          }
          /*if (date ==='' || new Date(date).getTime() > today.getTime()) {
                  errorMessage += ' La fecha de verificación del cuit debe ser menor o igual al día actual'
                }*/
          this.setState({ errorMessage: errorMessage });
          return errorMessage === "";

        //case 3: return true

        case 3:
          return true;
          if (this.state.tasks_data.equipment_type_id === "") {
            this.setState({
              errorMessage:
                "Debe completar los siguientes campos: nivel de equipamiento."
            });
          }
          return this.state.tasks_data.equipment_type_id !== "";
      }
    } else {
      return true;
    }
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    const { submitted, errors } = this.state;

    const handleBackStep = () => {
      if (this.handleValidations(this.state.activeStep) === true) {
        this.setState({ errorMessage: "" });
        this.setState({ activeStep: this.state.activeStep - 1 });
      }
    };

    const handleNextStep = () => {
      if (this.handleValidations(this.state.activeStep) === true) {
        this.setState({ errorMessage: "" });
        this.setState({ activeStep: this.state.activeStep + 1 });
      } else {
        this.setState({
          dialogOpen: true,
          message:
            "Hay errores en la carga o faltan carga campos. Por favor revisar",
          errors: true
        });
      }
    };

    const handleRedirect = url => () => {
      url = this.state.action === "new" ? "/providers" : "/providers";
      window.location.href = url;
    };

    const handleDialogClose = () => {
      this.setState({
        dialogOpen: false,
        meesage: "",
        error: "",
        delete_feature: "",
        address_id: "",
        feature_deleted: false,
        delete_address: false
      });
    };

    const steps = [
      "Datos proveedor",
      "Sucursales",
      "Datos impositivos",
      "Comentarios y adjuntos"
    ];
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle sm="4" title="Proveedor" className="text-sm-left" />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              {this.state.dialogOpen ? (
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Proveedor"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>{this.state.message}</DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    {this.state.delete_address ? (
                      <div>
                        <Button
                          onClick={this.handleDeleteAddress}
                          variant="contained"
                          color="primary"
                        >
                          Aceptar
                        </Button>
                        <Button
                          onClick={handleDialogClose}
                          variant="contained"
                          color="primary"
                        >
                          Cancelar
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.delete_feature ? (
                      <div>
                        <Button
                          className="mr-2"
                          onClick={this.handleConfirmDelete}
                          variant="contained"
                          color="primary"
                        >
                          Aceptar
                        </Button>
                        <Button
                          className="mr-2"
                          onClick={handleDialogClose}
                          variant="contained"
                          color="primary"
                        >
                          Cancelar
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.errors || this.state.feature_deleted ? (
                      <Button
                        onClick={handleDialogClose}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                    {this.state.save_provider ? (
                      <Button
                        onClick={handleRedirect()}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}
              {this.state.loading ? (
                <LinearProgress />
              ) : (
                <div>
                  <Stepper
                    activeStep={this.state.activeStep}
                    style={{
                      background: "inherit",
                      paddingTop: "12px",
                      paddingBottom: "12px"
                    }}
                  >
                    {steps.map(label => (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  <div>
                    <Typography>
                      <div className="row" className="mx-1">
                        {this.getStepContent(this.state.activeStep)}
                      </div>
                    </Typography>
                  </div>
                  <div className="mt-1">
                    {this.state.action === "view" ? (
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="secondary"
                        href={"/providers"}
                      >
                        Volver
                      </Button>
                    ) : (
                      ""
                    )}
                    <Button
                      variant="contained"
                      className="mt-3 ml-1 mr-1"
                      disabled={this.state.activeStep === 0}
                      onClick={handleBackStep}
                    >
                      Anterior
                    </Button>
                    {this.state.activeStep === steps.length - 1 ? (
                      this.state.action !== "view" ? (
                        <React.Fragment>
                          <Button
                            type="submit"
                            variant="contained"
                            className="mt-3 ml-1 mr-1"
                            color="primary"
                            onClick={e => this.handleSubmit(e)}
                          >
                            Guardar
                          </Button>
                        </React.Fragment>
                      ) : (
                        ""
                      )
                    ) : (
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="primary"
                        onClick={handleNextStep}
                      >
                        Siguiente
                      </Button>
                    )}
                  </div>
                </div>
              )}
            </React.Fragment>
          </Col>
        </Row>
        <React.Fragment>
          <Backdrop
            open={this.state.backdrop}
            onClick={this.handleCloseBackdrop}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <Typography className="ml-2" variant="h5" color="primary">
              Guardando...
            </Typography>
          </Backdrop>
        </React.Fragment>
      </Container>
    );
  }
}

export default ProviderForm;
